import React, {
  useMemo,
  memo,
} from 'react';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useFormik } from 'formik';
import {
  Modal,
  ModalBody,
  ModalHeader,
  Label,
  Col,
  Row,
  Input,
} from 'reactstrap';

import { ReactComponent as CloseButtonSvg } from 'assets/images/location/close-button-svg.svg';

import Button from 'components/App/Button';

import styles from './ModalEditPolicySmoke.module.scss';

function ModalEditPolicySmoke(props) {
  const {
    isOpen,

    allowSmoking,
    allowPet,

    actionGetPlaceDetail,
    actionEditSmokeAndPetPolicy,
    onToggleModal,
  } = props;

  const location = useLocation();
  const placeId = new URLSearchParams(location.search).get('place');

  const onCallBackSave = () => {
    onToggleModal();
    actionGetPlaceDetail({ placeId });
  };

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      allowPet,
      allowSmoking,
    },
    onSubmit: (values) => {
      const result = {
        allowPet: values.allowPet,
        allowSmoking: values.allowSmoking,
        placeId,
        onCallBackSave,
      };
      actionEditSmokeAndPetPolicy(result);
    },
  });

  const handleRadioChange = (e) => {
    validation.setFieldValue(e.target.name, !!+e.target.value);
  };

  const CloseButton = useMemo(() => (
    <button className={styles.ButtonClose} onClick={onToggleModal} type="button">
      <CloseButtonSvg />
    </button>
  ));

  return (
    <div className={styles.Component}>
      <Modal
        fade
        size="lg"
        isOpen={isOpen}
        toggle={onToggleModal}
        className={styles.Modal}
      >
        <ModalHeader
          toggle={onToggleModal}
          className={styles.ModalHeader}
          close={CloseButton}
        />
        <ModalBody
          className={styles.ModalBody}
        >
          <form onSubmit={validation.handleSubmit}>
            <Label className="Label">
              Chính sách hút thuốc và thú cưng
            </Label>

            <hr className="Divider" />

            <Row className="Block__Container mb-30">
              <Col md="5" className="Block__Title">
                Hút thuốc
              </Col>

              <Col md="7" className="Block__Content__Wrapper">
                <div className="Block__Content__Deposit">
                  <label className="Block__Checkbox__Wrapper">
                    <Input
                      type="radio"
                      className="Block__Checkbox"
                      name="allowSmoking"
                      value="1"
                      onChange={handleRadioChange}
                      defaultChecked={allowSmoking}
                    />

                    <div className="Block__Checkbox__Name">
                      Cho phép
                    </div>
                  </label>

                  <label className="Block__Checkbox__Wrapper">
                    <Input
                      type="radio"
                      className="Block__Checkbox"
                      name="allowSmoking"
                      value="0"
                      onChange={handleRadioChange}
                      defaultChecked={!allowSmoking}
                    />

                    <div className="Block__Checkbox__Name">
                      Không được phép
                    </div>
                  </label>
                </div>
              </Col>
            </Row>

            <hr className="Divider" />

            <Row className="Block__Container mb-30">
              <Col md="5" className="Block__Title">
                Thú cưng
              </Col>

              <Col md="7" className="Block__Content__Wrapper">
                <div className="Block__Content__Deposit">
                  <label className="Block__Checkbox__Wrapper">
                    <Input
                      type="radio"
                      className="Block__Checkbox"
                      name="allowPet"
                      value="1"
                      onChange={handleRadioChange}
                      defaultChecked={allowPet}
                    />

                    <div className="Block__Checkbox__Name">
                      Cho phép
                    </div>
                  </label>

                  <label className="Block__Checkbox__Wrapper">
                    <Input
                      type="radio"
                      className="Block__Checkbox"
                      name="allowPet"
                      value="0"
                      onChange={handleRadioChange}
                      defaultChecked={!allowPet}
                    />

                    <div className="Block__Checkbox__Name">
                      Không được phép
                    </div>
                  </label>
                </div>
              </Col>
            </Row>

            <hr className="Divider" />

            <div className="Block__Policy__Wrapper">
              <Col md="5" className="Block__Title mb-8">
                Tóm tắt chính sách
              </Col>

              <div className="Block__Policy__Information__Wrapper">
                <div className="Block__Policy__Information__Point">•</div>

                <div className="Block__Policy__Information__Content">
                  Khách
                  {' '}
                  {!validation.values.allowSmoking && 'không '}
                  được hút thuốc trong chỗ nghỉ
                </div>
              </div>

              <div className="Block__Policy__Information__Wrapper">
                <div className="Block__Policy__Information__Point">•</div>

                <div className="Block__Policy__Information__Content">
                  Khách
                  {' '}
                  {!validation.values.allowPet && 'không '}
                  được mang thú cưng
                </div>
              </div>
            </div>

            <hr className="Divider" />

            <div className="Button__Wrapper">
              <Button
                classes="Button Button__Cancel"
                onClick={onToggleModal}
              >
                Hủy
              </Button>

              <Button classes="Button Button__Save" type="submit">
                Lưu
              </Button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    </div>
  );
}

ModalEditPolicySmoke.propTypes = {
  isOpen: PropTypes.bool.isRequired,

  allowPet: PropTypes.bool.isRequired,
  allowSmoking: PropTypes.bool.isRequired,

  actionGetPlaceDetail: PropTypes.func.isRequired,
  actionEditSmokeAndPetPolicy: PropTypes.func.isRequired,
  onToggleModal: PropTypes.func.isRequired,
};

ModalEditPolicySmoke.defaultProps = {

};

export default memo(ModalEditPolicySmoke);
